import React, { useEffect, useState } from 'react'
import { Input, Label } from '../../Shared'
import { useAppContext } from '../../context/AppContext';
import axios from 'axios';
import States from '../../components/States';

const MailProvider = ({company, onClose, provider,reset,setReset,editProviderItemId}) => {
      const [editItemId, setEditItemId] = useState(null);

       const { user, axiUrl } = useAppContext();
      
      
      
        console.log(provider);
        
        const [formData, setFormData] = useState({
          id:null,
          providerName:"" ,
          name:"",
  address:"",
  address2:"",
  city:"" ,
  state:"FL" ,
  zip:"" ,
  telephone:"" ,
 crid:"" ,
  mid:"" ,
  repname:"" ,
repphone:"" ,
repemail:"" ,
einduction:false ,
seamless:false ,
company: company
        });
     
      
        useEffect(() => {
          if (provider) {
            setFormData({
              id:provider._id,
              providerName:provider.providerName ,
              name:provider.name ,
  address:provider.address ,
  address2:provider.address2 ,
  city:provider.city ,
  state:provider.state ,
  zip:provider.zip ,
  telephone:provider.telephone ,
 crid:provider.crid ,
  mid:provider.mid ,
  repname:provider.repname ,
repphone:provider.repphone ,
repemail:provider.repemail ,
einduction:provider.einduction ,
seamless:provider.seamless ,
company: company
            });
          }
        }, [provider]);


 const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };


    const handleSubmit = async (e) => {
    e.preventDefault();
   
        const url = editProviderItemId ? `${axiUrl}/permits/updateproviderr` : `${axiUrl}/permits/addmailprovider`;
        const payload = editProviderItemId ? { ...formData, id: editProviderItemId } : formData;
console.log('paylod',payload)
   const res = await axios.post(url, payload)
      .then(res => {console.log(res.data)
       setReset(!reset);
    onClose();
  })
       
  };

console.log(formData)
  
  return (
    <div className='w-full'>
<form onSubmit={handleSubmit}>
<div className='flex w-full gap-[20px]'>
    <div class='flex-3 relative'>
        <div className='w-full'><Label>Mail Agent or Mail Service Provider</Label></div>
        <div><Input value={formData.providerName} name="providerName" onChange={handleChange} type="text" required/></div>
        <div className='relative p-3 border border-gray-400 mt-3 pb-6'>
    <h2 class="absolute -top-[13px] bg-white px-[3px]">Mail Agent Information</h2>
    <div className='mb-[6px]'><Label fontSize="12px" mb="2px">Company Name</Label><Input value={formData.name} name="name" onChange={handleChange} width="100%" required/></div>
    <div  className='mb-[6px]'><Label fontSize="12px" mb="2px">Address 1</Label><Input value={formData.address} name="address" onChange={handleChange} width="100%" required/></div>
    <div  className='mb-[6px]'><Label fontSize="12px" mb="2px">Address 2</Label><Input value={formData.address2} name="address2" onChange={handleChange} width="100%"/></div>
    <div className='flex gap-[5px]'>
         <div className='mb-[6px] flex-2 gap-[5px]'><Label fontSize="12px" mb="2px">City</Label><Input value={formData.city} name="city" onChange={handleChange} width="100%" required/></div>
    <div  className='mb-[6px] flex-1'><Label fontSize="12px" mb="2px">State</Label>  <States setFormData={setFormData} formData={formData} required/></div>
    <div  className='mb-[6px] flex-1'><Label fontSize="12px" mb="2px">Zip</Label><Input value={formData.zip} name="zip" onChange={handleChange} width="100%" required/></div>
    </div>

  <div className='flex gap-[5px]'>
         <div className='mb-[6px] flex-1 gap-[5px]'><Label fontSize="12px" mb="2px">Mail Agent CRID</Label><Input value={formData.crid} name="crid" onChange={handleChange} width="100%" required/></div>
    <div  className='mb-[6px] flex-1'><Label fontSize="12px" mb="2px">Mail Agent MID</Label><Input value={formData.mid} name="mid" onChange={handleChange} width="100%"/></div>
    </div>


  </div>
  <br />
</div>
    </div>

   <div>
  <div className='relative p-3 border border-gray-400 pb-6'>
    <h2 class="absolute -top-[13px] bg-white px-[3px] ">Mailing Agent Information</h2>
    <div className='flex gap-[10px]'>
 <div className='flex-[1.5]  mt-[6px] '><Label  fontSize="12px" mb="2px">Represenative Name (First Last)</Label><Input value={formData.repname} name="repname" onChange={handleChange} width="100%" required/></div>
  <div className='flex-1 relative  mt-[6px] '><Label fontSize="12px" mb="2px" width="100%">Phone Number</Label><Input value={formData.repphone} name="repphone" onChange={handleChange} width="100%" />
    </div>
      <div className='flex-[1.5]  mt-[6px] '><Label  fontSize="12px" mb="2px">Email</Label><Input value={formData.repemail} name="repemail" onChange={handleChange} width="100%" required/></div> 
</div>

   </div>


    <div>
<div className="relative p-3 border border-gray-400 pb-6">
      <h2 className="absolute -top-[13px] bg-white px-[3px]">Service Options</h2>
      <div className="flex">
        <div className="pl-[12px] flex-1">
          <label className="inline-flex items-center mt-2">
            <input
              type="checkbox"
              className="mr-2"
              name="einduction"
              checked={formData.einduction} // Use boolean directly
              onChange={handleChange}
            />
            <span className="text-sm text-gray-700">eInduction</span>
          </label>
        </div>
        <div className="pl-[12px] flex-1">
          <label className="inline-flex items-center mt-2">
            <input
              type="checkbox"
              className="mr-2"
              name="seamless"
              checked={formData.seamless} // Use boolean directly
              onChange={handleChange}
            />
            <span className="text-sm text-gray-700">Seamless Acceptance</span>
          </label>
        </div>
      </div>
    </div>

   </div>


 <div className="flex justify-end space-x-2 mt-[10px]">
              <button
                type="button"
                onClick={() => {
                 onClose()
                }}
                className="text-[12px] px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="text-[12px] px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
              >
                {editProviderItemId ? 'Update Provider' : 'Add Provider'}
              </button>
            </div>
   <div>
  
   </div>
   
    </div>
    </form>
    </div>
  )
}

export default MailProvider